export default class MediaExtradata {
    /**
     * @type {string}
     * @memberof MediaExtradata
     * @name 课时ID
     */
    public class_id: string
    /**
     * @type {string}
     * @memberof MediaExtradata
     * @name 空间ID
     */
    public container_id: string
    /**
     * @type {string}
     * @memberof MediaExtradata
     * @name 资源ID
     */
    public resource_id: string
    /**
     * @type {number}
     * @memberof MediaExtradata
     * @name 开始观看时间，时间戳ms
     */
    public watch_at: number
    /**
     * @type {number}
     * @memberof MediaExtradata
     * @name 观看时长 10s
     */
    public look_time: number
    constructor({
        class_id = '',
        container_id = '',
        resource_id = '',
        watch_at = null,
        look_time = null
    } = {}) {
        this.class_id = class_id
        this.container_id = container_id
        this.resource_id = resource_id
        this.watch_at = watch_at
        this.look_time = look_time
    }
}